import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../../static/icons/default-image.svg'


const _hoisted_1 = {
  key: 0,
  class: "ambassador"
}
const _hoisted_2 = { class: "ambassador__main-media-container" }
const _hoisted_3 = { class: "ambassador__main-media" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ambassador__main-spacer" }, null, -1)
const _hoisted_5 = ["srcset"]
const _hoisted_6 = {
  key: 0,
  class: "ambassador__profile-media"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ambassador__profile-spacer" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "ambassador__text-container"
}

import Text from "@/blocks/Text/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ambassador',
  props: {
  main: {
    type: String,
    required: true,
  },
  profile: {
    type: String,
    required: true,
  },
  text: {
    type: Object,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (__props.main)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("img", {
              class: "ambassador__main-image",
              srcset: __props.main,
              src: _imports_0
            }, null, 8, _hoisted_5)
          ]),
          (__props.profile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("img", {
                  class: "ambassador__profile-image",
                  src: __props.profile
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(Text, { block: __props.text }, null, 8, ["block"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})